var styles = {"box":"BasePopup_box_1xzs6_1","horizontalLeftOut":"BasePopup_horizontalLeftOut_1xzs6_1","horizontalLeftIn":"BasePopup_horizontalLeftIn_1xzs6_1","medium":"BasePopup_medium_1xzs6_7","small":"BasePopup_small_1xzs6_10","primary":"BasePopup_primary_1xzs6_13","outline":"BasePopup_outline_1xzs6_19"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
